export enum UnitDisplaySettingTypeEnum {
  PermanentlyOn = 0,
  AccordingTimetable = 1,
}

export enum UnitLEDSettingTypeEnum {
  PermanentlyOn = 0,
  PermanentlyOff = 1,
  AccordingTimetable = 2,
}

export interface TimetableSlotSettings {
  day: number;
  periodStart: string;
  periodEnd: string;
}

export interface UnitTimetableSettings {
  name: string;
  timeTableSettings: TimetableSlotSettings[];
}

export interface UnitDisplayLedSettings {
  unitDisplaySettingType: UnitDisplaySettingTypeEnum;
  unitSideLEDIndicationSettingType: UnitLEDSettingTypeEnum;
  unitDisplayTimeTable: UnitTimetableSettings;
  unitSideLEDIndicationTimeTable: UnitTimetableSettings;
}
